import * as React from 'react';

import { HeaderContainer as RedesignHeaderContainer } from './Redesign';

export const HeaderLoadable: React.FC = () => {
  return <RedesignHeaderContainer />;
};
